import { Injectable } from '@angular/core';

@Injectable()
export class SessionStoreService {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/services/session-store/session-store.service.ts